import { FC } from "react";
import { useTranslation } from "react-i18next";

import { HelpTopicContentLocale } from "@ryde/shared";

import {
  HelpTopicLanguageFlagButtonStyled,
  HelpTopicLanguageSwitcherStyled,
} from "./help-topic-language-switcher.styled";

interface IHelpTopicLanguageSwitcherProps {
  locale: HelpTopicContentLocale;
  hasHebrewTranslation: boolean;
  onLocaleChange: (locale: HelpTopicContentLocale) => void;
}

export const HelpTopicLanguageSwitcher: FC<IHelpTopicLanguageSwitcherProps> = ({
  locale,
  hasHebrewTranslation,
  onLocaleChange,
}) => {
  const { t } = useTranslation();

  return (
    <HelpTopicLanguageSwitcherStyled
      role="group"
      aria-label={t("helpTopics.languageSwitcher", {
        defaultValue: "Help topic language",
      })}
    >
      <HelpTopicLanguageFlagButtonStyled
        type="button"
        $active={locale === "en"}
        onClick={() => onLocaleChange("en")}
        aria-label={t("helpTopics.languageEnglish", {
          defaultValue: "English",
        })}
        aria-pressed={locale === "en"}
      >
        <span className="HelpTopicLanguageSwitcher-Flag" aria-hidden>
          🇬🇧
        </span>
        <span className="HelpTopicLanguageSwitcher-Label">EN</span>
      </HelpTopicLanguageFlagButtonStyled>
      <HelpTopicLanguageFlagButtonStyled
        type="button"
        $active={locale === "he"}
        disabled={!hasHebrewTranslation}
        onClick={() => onLocaleChange("he")}
        aria-label={t("helpTopics.languageHebrew", {
          defaultValue: "עברית",
        })}
        aria-pressed={locale === "he"}
        title={
          hasHebrewTranslation
            ? undefined
            : t("helpTopics.languageHebrewUnavailable", {
                defaultValue: "Hebrew translation not available",
              })
        }
      >
        <span className="HelpTopicLanguageSwitcher-Flag" aria-hidden>
          🇮🇱
        </span>
        <span className="HelpTopicLanguageSwitcher-Label">עב</span>
      </HelpTopicLanguageFlagButtonStyled>
    </HelpTopicLanguageSwitcherStyled>
  );
};
